import { render, staticRenderFns } from "./HeaderNavigationPackages.vue?vue&type=template&id=28a81b7a&scoped=true&"
import script from "./HeaderNavigationPackages.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigationPackages.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNavigationPackages.vue?vue&type=style&index=0&id=28a81b7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a81b7a",
  null
  
)

export default component.exports